<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <OverviewReport />
  </v-container>
</template>

<script>
import OverviewReport from '../components/report-executive/OverviewReport.vue';

export default {
  name: 'ReportExecutive',
  components: {
    OverviewReport
  },
  data: () => ({}),
  mounted() {
    this.$emit('gobacktolink', 'dashboard_report');
  },
  methods: {}
};
</script>
